// src/pages/SignIn.tsx
import React, { FC, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import LeftPanel from './components/LeftPanel';
import SignInForm from './components/SignInForm';
import Divider from './components/Divider';
import AuthService from '@/services/AuthService';
import SocialButton from './components/subComponents/SocialButton';
import { Icons } from '@/icons';
import { toast } from 'react-toastify';
import FacebookLogin from '@greatsumini/react-facebook-login';

const { Facebook, Google } = Icons;

const SignIn: FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  // Google OAuth hook
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    scope: 'openid email profile',
    onSuccess: async (response) => {
      const code = response.code;
      // 2) send that code to your backend
      const result = await AuthService.googleLogin(code);
      if (result.success) {
        navigate(getPostLoginTarget(), { replace: true });
      } else {
        toast.error(result.message ?? 'Google login failed');
      }
    },
    onError: () => toast.error('Google login failed'),
  });

  // Facebook login response handler
  const responseFacebook = async (response: any) => {
    if (response.status !== 'unknown') {
      const { accessToken } = response;
      console.log('Facebook access token:', accessToken);

      // Send the Facebook access token to your backend for authentication
      // const result = await AuthService.facebookLogin(accessToken);
      // if (result.success) {
      //   navigate(AuthService.getRedirect(), { replace: true });
      // } else {
      //   toast.error(result.message ?? 'Facebook login failed');
      // }
    } else {
      toast.error('Facebook login failed');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await AuthService.login(email, password);
    if (result.success) {
      navigate(getPostLoginTarget(), { replace: true });
    } else {
      // toast.error(result.message ?? 'Login failed');
    }
  };

  // BINGEPLAY-MCP-OAUTH-V1: if the user reached /login as part of the
  // OAuth consent bounce, we recorded their return target in
  // localStorage. Honor that over the role-based default so they land
  // back on /oauth/consent after signing in and can Approve.
  function getPostLoginTarget(): string {
    try {
      const stored = localStorage.getItem('bp_post_login_redirect');
      if (stored) {
        localStorage.removeItem('bp_post_login_redirect');
        return stored;
      }
      const nextParam = new URLSearchParams(window.location.search).get(
        'next',
      );
      if (nextParam) return nextParam;
    } catch {}
    return AuthService.getRedirect();
  }

  return (
    <div className='flex flex-col lg:flex-row h-screen'>
      <LeftPanel />

      {/* Right side */}
      <div className='w-full lg:w-1/2 p-6 sm:p-8 lg:p-10 flex flex-col'>
        {/* Center content */}
        <div className='flex-1 flex flex-col items-center justify-center'>
          <div className='w-full md:w-[640px] lg:w-[500px] xl:w-[460px] flex flex-col items-center justify-center'>
            <h2 className='text-2xl sm:text-3xl lg:text-4xl xl:text-4xl font-semibold mb-2'>
              Welcome Back
            </h2>
            <p className='text-sm text-gray-500 mb-6'>
              Sign in to continue your experience
            </p>

            <SignInForm
              email={email}
              password={password}
              onEmailChange={(e) => setEmail(e.currentTarget.value)}
              onPasswordChange={(e) => setPassword(e.currentTarget.value)}
              onSubmit={handleSubmit}
            />

            <Divider />

            <div className='flex flex-row space-y-0 lg:space-y-3 w-full'>
              <SocialButton
                shortLabel='Google'
                icon={Google}
                label='Continue with Google'
                onClick={() => googleLogin()}
              />
            </div>
          </div>
        </div>

        {/* Bottom link */}
        <div className='mt-auto'>
          <p className='text-xs sm:text-sm md:text-base text-button text-black mt-4 text-center'>
            Don’t have an account?{' '}
            <Link
              to='/create-account'
              className='text-xs sm:text-sm md:text-base text-[#14D8CE] hover:underline'
            >
              Create Account
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
